export default class TierRepository {
  constructor(tierApiService, localStorageService, pricingSocketService) {
    if (new.target === TierRepository) {
      throw new Error("Cannot instantiate an abstract class.");
    }

    if (this.updateUserSubscription === TierRepository.prototype.updateUserSubscription) {
      throw new Error("Class extending TierRepository must override 'updateUserSubscription({ userId })'.");
    }

    if (this.subscribeTier === TierRepository.prototype.subscribeTier) {
      throw new Error(
        "Class extending TierRepository must override 'subscribeTier({ tierId, userId, onSuccess, onFailed, onError, onDone, onNoBillingAddress, onNoPaymentMethod })'."
      );
    }

    if (this.getTierById === TierRepository.prototype.getTierById) {
      throw new Error("Class extending TierRepository must override 'getTierById(tierId)'.");
    }

    if (this.reactivateTier === TierRepository.prototype.reactivateTier) {
      throw new Error("Class extending TierRepository must override 'reactivateTier(data)'.");
    }

    this.tierApiService = tierApiService;
    this.localStorageService = localStorageService;
    this.pricingSocketService = pricingSocketService;
  }

  async getActiveTiers() {
    throw new Error("Method 'getActiveTiers()' must be implemented.");
  }

  async subscribeTier({ tierId, userId, onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod }) {
    throw new Error(
      "Method 'subscribeTier({ tierId, userId, onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod })' must be implemented."
    );
  }

  async unsubscribeTier(data) {
    throw new Error("Method 'unsubscribeTier(data)' must be implemented.");
  }

  async getTierAddons() {
    throw new Error("Method 'getTierAddons' must be implemented.");
  }

  async updateUserSubscription({ userId }) {
    throw new Error("Method 'updateUserSubscription({ userId })' must be implemented.");
  }

  async getTierById(tierId) {
    throw new Error("Method 'getTierById(tierId)' must be implemented.");
  }

  async reactivateTier() {
    throw new Error("Method 'reactivateTier(data)' must be implemented.");
  }
}
